<!------------------------------

      Page Actions

------------------------------->

<div class="tw-flex tw-justify-end tw-gap-2 tw-mb-3">

  <button
    type="button"
    sb-button-primary
    color="blue"
    sbTooltip="{{ 'lang.globals.refresh' | translate }}" placement="top"
    container="body"
    [iconButton]="true"
    [icon]="'refresh'"
    (click)="requestDebounced()"
    [disabled]="loading()"
    [loading]="loading()">
  </button>

  <button
    type="button"
    sb-button-primary
    [color]="'blue'"
    [icon]="'list'"
    [loading]="loading()"
    [iconButton]="true"
    [sbRouterLink]="util.RoutingID.devices"
    [queryParams]="{'locationIds': getLocationId()}"
    sbTooltip="{{ 'lang.globals.showInList' | translate }}"
  >
  </button>

</div>

<!------------------------------

     Table Wrapper

------------------------------->

<sb-table-wrapper-new
  headline="{{'lang.headlines.devices' | translate}}"
  [isInIntegratedContext]="true"
  [itemsData]="devices"
  (paginationChange)="requestDebounced($event)"
  [loading]="loading()"
  [itemName]="'devices'">

  <!------------------------------

    Filter Panel

------------------------------->

  <div filter-panel class="tw-bg-[#F8F9FC] dark:tw-bg-sbGray-930 tw-rounded-l-xl">
    <sb-filter-panel
      (filterChange)="applyFiltering($event)"
      [headerClasses]="'tw-bg-sbGray-50 dark:tw-bg-sbGray-930 tw-border-solid tw-border-0 tw-z-40 tw-border-b tw-border-sbGray-500 dark:tw-border-sbGray-50 tw-h-[60px] tw-rounded-tl-xl'"
      [config]="filterConfig"
    >

    </sb-filter-panel>
  </div>

  <!------------------------------

      Table Header

------------------------------->
  <ng-template #thead>
    <tr>
      <th>
        {{ 'lang.globals.status' | translate }}
      </th>
      <th>
        {{ 'lang.globals.connection' | translate }}
      </th>
      <th>
        {{ 'lang.globals.id' | translate }}
      </th>
      <th>
        {{ 'lang.globals.channel' | translate }}
      </th>
      <th class=" sticky-col last-col">
        {{ 'lang.globals.action' | translate }}
      </th>
    </tr>
  </ng-template>
  <!------------------------------

    Table Body

------------------------------->
  <ng-template #tbody let-device>
    <tr>
      <td>
            <span class="cursor-help" [ngbTooltip]="deviceService.iconTooltip(device)" placement="right"
                  container="body">
              <sb-icon class="mr-1" [icon]="deviceService.icon(device)"
                       [ngClass]="deviceService.iconColor(device)"></sb-icon>
              <span [ngClass]="deviceService.iconColor(device)">{{ deviceService.iconText(device) }}</span>
              @if (device?.serviceRequest) {
                <span [ngClass]="deviceService.iconColor(device)">&nbsp;{{ 'lang.locationDevices.service' | translate }}</span>
              }
            </span>
      </td>
      <td>
        <!-- id/status/... Column -->
        <p class="mb-1">
              <span [ngClass]="deviceService.iconColor(device)" [ngbTooltip]="deviceService.lastOnlineTitle(device)"
                    placement="right" container="body"
                    class="cursor-help">{{ deviceService.lastOnline(device) }}
              </span>
        </p>
        <!---->
      </td>
      <td>
        {{ device?.id }}
      </td>
      <td>
        <sb-comp-link
          class="link font-weight-bold"
          [title]="device?.channel?.name"
          [permission]="permissionService.Permission.channel_show"
          [link]="util.RoutingID.channelDetails" [pathParams]="[{id: 'channelID', value: device?.channel?.id}]">
        </sb-comp-link>
      </td>
      <td class="ticky-col last-col">
        <sb-split-button
          [splitButtonItems]="device.sbButtons ?? []"
        ></sb-split-button>
      </td>
    </tr>
  </ng-template>
</sb-table-wrapper-new>
